import { CheckCircle, CircleNotch, Receipt } from '@phosphor-icons/react';

import { Check } from '@phosphor-icons/react';
import { monthNames } from '../../../../shared/constants/dates';
import { Tool } from '../../../../@types/IA.type';
import { useState } from 'react';

const GenerateComplementaryDeclarationTool = ({
	tool,
	userIsPlatec,
	userProfile,
}: {
	tool: Tool;
	userIsPlatec?: boolean;
	userProfile?: any;
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isAlreadyGenerated, setIsAlreadyGenerated] = useState(false);

	const generateComplementary = async () => {
		try {
			if (!userProfile?.id) {
				throw new Error('Usuario no encontrado');
			}
			setIsLoading(true);
			// const response = await sendExtraction({
			// 	userId: userProfile?.id!,
			// 	type: 'PLATEC_CAPTURE_LINE',
			// 	month: tool.args.month,
			// 	year: tool.args.year,
			// });
			setIsAlreadyGenerated(true);
		} catch (error) {
			throw error;
		} finally {
			setIsLoading(false);
		}
	};

	if (!userIsPlatec) {
		return (
			<div>
				Lo sentimos, solo puedes generar una declaración complementaria si eres
				un usuario de Platec.
			</div>
		);
	}

	return (
		<div className='flex flex-col gap-2 bg-white rounded-2xl p-2 w-fit shadow'>
			{isAlreadyGenerated ? (
				<div className='flex gap-2 items-center'>
					<div className='p-2 bg-h-primary-90/50 rounded-lg w-fit'>
						<CheckCircle
							className='size-5 text-h-primary'
							weight='duotone'
						/>
					</div>
					<div className='p-1'>
						<p className='font-medium'>
							Tu nueva línea de captura está en proceso.
						</p>
						<p className='font-light'>
							Te enviaremos un mensaje cuando esté lista.
						</p>
					</div>
				</div>
			) : (
				<div className='flex gap-2 items-center'>
					<div className='p-2 bg-h-primary-90/50 rounded-lg w-fit'>
						<Receipt
							className='size-5 text-h-primary'
							weight='duotone'
						/>
					</div>
					<div className='p-1'>
						<div className='font-medium'>Generar nueva línea de pago</div>
						<div className='font-light opacity-70'>
							Declaración complementaría{' '}
							<b>
								{monthNames[tool.args.month - 1]} {tool.args.year}
							</b>
						</div>
					</div>
				</div>
			)}
			{isAlreadyGenerated ? (
				<button className='h-9 flex gap-2 items-center justify-center border border-h-neutral-90 text-h-neutral-30 rounded-lg p-2'>
					Solicitud enviada{' '}
					<Check
						className='min-w-[14px]'
						weight='bold'
					/>
				</button>
			) : (
				<button
					onClick={generateComplementary}
					disabled={isLoading}
					className='h-9 flex gap-2 items-center justify-center bg-h-primary text-white rounded-lg p-2'
				>
					{isLoading ? (
						<CircleNotch
							className='animate-spin text-white'
							weight='bold'
						/>
					) : (
						<>
							Confirmar
							<Check
								className='min-w-[14px]'
								weight='bold'
							/>
						</>
					)}
				</button>
			)}
		</div>
	);
};

export default GenerateComplementaryDeclarationTool;
